/* src/app/modules/shared/components/header-column/header-column-variant-type/header-column-variant-type.component.scss */
/*# sourceMappingURL=header-column-variant-type.component.css.map */
